import React from 'react';

import { Box, Typography, CircularProgress, styled } from '@mui/material';

import { ExportStatus } from '../../types';

const CenteredBox = styled(Box)({
  textAlign: 'center',
});

const LoadingBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 3,
});

interface ExportProgressDetailsProps {
  exportStatus: ExportStatus;
  pollAttempts: number;
  maxPollAttempts: number;
}

export const ExportProgressDetails = ({ 
  exportStatus, 
  pollAttempts, 
  maxPollAttempts 
}: ExportProgressDetailsProps) => {
  const isPending = exportStatus.status === 'pending';
  const hasReachedMaxAttempts = pollAttempts >= maxPollAttempts;

  return (
    <CenteredBox>
      <Box sx={{ mb: 3 }}>
        <LoadingBox>
          <CircularProgress size={40} />
        </LoadingBox>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {hasReachedMaxAttempts 
            ? 'Export is taking longer than expected. You can close this dialog and check GruntWorx dashboard for status.'
            : isPending 
              ? 'Export queued for processing...' 
              : 'Processing files...'}
        </Typography>
        
        {exportStatus.export_id && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Export ID: {exportStatus.export_id}
          </Typography>
        )}
        
        {!hasReachedMaxAttempts && (
          <Typography variant="body2" color="text.secondary">
            Checking export status... (Attempt {pollAttempts} of {maxPollAttempts})
          </Typography>
        )}
      </Box>
    </CenteredBox>
  );
}; 